import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { MessageService } from 'primeng/api';
import { PermissionService } from './../../service/permission.service';
import { ObjectNames } from '../../shared/constants';


@Injectable()
export class GoalGuardService  {
    constructor(
        public permissionService: PermissionService,
        public router: Router,
	    private messageService: MessageService,

    ) {
      
    }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const userPermissions = this.permissionService.getPemrissionData();
        const goalPermissions = userPermissions.find(obj => obj.objectName == ObjectNames.GOAL);

        const readPermission = goalPermissions && goalPermissions.permissions[0] ? goalPermissions.permissions[0].statusId == 1 : false;
        const writePermission = goalPermissions && goalPermissions.permissions[1] ? goalPermissions.permissions[1].statusId == 1 : false;
        const editPermission = goalPermissions && goalPermissions.permissions[2] ? goalPermissions.permissions[2].statusId == 1 : false;
        const deletePermission = goalPermissions && goalPermissions.permissions[3] ? goalPermissions.permissions[3].statusId == 1 : false;
        const exportPermission = goalPermissions && goalPermissions.permissions[4] ? goalPermissions.permissions[4].statusId == 1 : false;

        const permission = readPermission || writePermission || editPermission || deletePermission || exportPermission;
        
        if(!permission){
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'You don\'t have permission to access Goal' });
        }
        return permission;
    }
}